/*
 * Abba & Co. header: turns the bar Navy after 40px of scrolling
 * (html.ab-scrolled), flips the wordmark's ampersand on hover, and opens the
 * Shop and Gift a cap panels (sections/abbaco-mega-menus.liquid) on hover.
 * Horizon can scroll inside .page-wrapper, so both scrollers are watched.
 */
(() => {
  const root = document.documentElement;

  const scrolled = () => {
    const wrapper = document.querySelector('.page-wrapper');
    const y = Math.max(window.scrollY || 0, root.scrollTop || 0, wrapper ? wrapper.scrollTop : 0);
    root.classList.toggle('ab-scrolled', y > 40);
  };
  window.addEventListener('scroll', scrolled, { passive: true, capture: true });
  scrolled();

  const setUp = () => {
    const amp = document.querySelector('.header-logo .abbaco-wordmark__amp');
    if (amp) {
      let turns = 0;
      amp.closest('.header-logo').addEventListener('mouseenter', () => {
        turns += 1;
        amp.style.transform = `perspective(600px) rotateY(${turns * 360}deg)`;
      });
    }

    const header = document.getElementById('header-component');
    const panels = document.querySelectorAll('[data-ab-mega]');
    if (!header || !panels.length) return;

    const wide = window.matchMedia('(min-width: 990px)');
    const links = [...header.querySelectorAll('.menu-list__link')];
    const pairs = [];

    panels.forEach((panel) => {
      header.appendChild(panel);
      const name = (panel.dataset.trigger || '').trim().toLowerCase();
      const link = links.find((a) => a.textContent.trim().toLowerCase() === name);
      if (!link) return;
      link.setAttribute('aria-expanded', 'false');
      link.setAttribute('aria-controls', panel.id);
      const title = link.querySelector('.menu-list__link-title') || link;
      title.insertAdjacentHTML(
        'beforeend',
        '<svg class="ab-chevron" width="9" height="9" viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M2 3.5 5 6.5 8 3.5"/></svg>'
      );
      pairs.push({ link, panel });
    });

    const close = () =>
      pairs.forEach(({ link, panel }) => {
        link.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
      });

    const open = (pair) => {
      if (!wide.matches) return;
      pairs.forEach((p) => {
        const on = p === pair;
        p.link.setAttribute('aria-expanded', String(on));
        p.panel.hidden = !on;
      });
    };

    pairs.forEach((pair) => {
      pair.link.addEventListener('mouseenter', () => open(pair));
      pair.link.addEventListener('focus', () => open(pair));
    });
    links
      .filter((a) => !pairs.some((p) => p.link === a))
      .forEach((a) => {
        a.addEventListener('mouseenter', close);
        a.addEventListener('focus', close);
      });
    header.addEventListener('mouseleave', close);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
    header.addEventListener('focusout', (e) => {
      if (!header.contains(e.relatedTarget)) close();
    });
    wide.addEventListener('change', close);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setUp);
  else setUp();
})();

/* Story pages menu bar on phones: bring the current page into view */
document.addEventListener('DOMContentLoaded', () => {
  const cur = document.querySelector('.abw .switch a[aria-current="page"]');
  if (cur && cur.parentElement) { const bar = cur.parentElement; bar.scrollLeft = cur.getBoundingClientRect().left - bar.getBoundingClientRect().left + bar.scrollLeft - (bar.clientWidth - cur.offsetWidth) / 2; }
});
